// Tour Timeline container — hosts a Vehicle / Tour view toggle. The Tour view
// reuses the existing TourTimelinePage unchanged; the Vehicle view is the new
// vehicle-centric scheduling grid (rows = vehicles, columns = a 90-day window).
// Route /tour-timeline points here; the page/nav name stays "Tour Timeline".

import React, { useState } from 'react';
import TourTimelinePage from '../TourTimeline/TourTimelinePage';
import VehicleSchedulePage from './VehicleSchedulePage';
import { useThemeStore } from '../stores/useThemeStore';

type View = 'vehicle' | 'tour';

const TOGGLE: { key: View; label: string }[] = [
  { key: 'vehicle', label: 'Transport' },
  { key: 'tour', label: 'Tour' },
];

const SchedulePage: React.FC = () => {
  const [view, setView] = useState<View>('vehicle');
  const dayMode = useThemeStore(s => s.dayMode);
  // Light canvas only for the (day-aware) Vehicle view. The legacy Tour view has
  // no day: styling, so it — and the toggle sitting above it — stays dark.
  const light = view === 'vehicle' && dayMode;

  return (
    <div className={light ? 'min-h-page day-mode bg-gray-50 text-gray-900' : ''}>
      <div className="flex items-center gap-1 px-4 pt-4">
        <div className={`inline-flex rounded-md border overflow-hidden ${light ? 'border-gray-200' : 'border-gray-700/60'}`}>
          {TOGGLE.map(({ key, label }) => (
            <button
              key={key}
              onClick={() => setView(key)}
              className={`px-3.5 py-1.5 text-sm transition-colors ${
                view === key
                  ? 'bg-primary text-black font-semibold'
                  : light
                    ? 'bg-white text-gray-600 hover:text-gray-900 hover:bg-gray-100'
                    : 'bg-gray-900 text-on-surface-variant day:text-gray-400 hover:text-on-surface day:hover:text-gray-200 hover:bg-surface-container-low'
              }`}
            >
              {label}
            </button>
          ))}
        </div>
      </div>

      {view === 'vehicle' ? <VehicleSchedulePage /> : <TourTimelinePage />}
    </div>
  );
};

export default SchedulePage;
